import { useEffect } from "react";
import { motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const PageShell = ({ overline, title, italic, children, testid }) => {
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid={testid} className="bg-[#060B18] text-slate-100 min-h-screen">
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-amber-400/90 mb-5"
        >
          {overline}
        </motion.p>
        <h1 className="font-serif font-bold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl text-amber-50">
          <span className="block overflow-hidden pb-1">
            <motion.span
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.35 }}
              className="block"
            >
              {title} <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA7C11]">{italic}</span>
            </motion.span>
          </span>
        </h1>
      </section>
      {children}
      <Footer />
    </main>
  );
};
